"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _IllustrationHighHouseComposition = _interopRequireDefault(require("../../illustrations/General/IllustrationHighHouseComposition"));
var _IllustrationHouseComposition = _interopRequireDefault(require("../../illustrations/General/IllustrationHouseComposition"));
var _IllustrationLowHouseComposition = _interopRequireDefault(require("../../illustrations/General/IllustrationLowHouseComposition"));
var _IllustrationSemiDetachedHouseComposition = _interopRequireDefault(require("../../illustrations/General/IllustrationSemiDetachedHouseComposition"));
var _IllustrationSmallHouseComposition = _interopRequireDefault(require("../../illustrations/General/IllustrationSmallHouseComposition"));
var _IllustrationTerraceBlockComposition = _interopRequireDefault(require("../../illustrations/General/IllustrationTerraceBlockComposition"));
var _IllustrationTownHouseComposition = _interopRequireDefault(require("../../illustrations/General/IllustrationTownHouseComposition"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const UnitIllustration = ({
  type
}) => {
  switch (type) {
    case 'Lavblokk':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IllustrationLowHouseComposition.default, {
        withBackground: true
      });
    case 'Rekkehus':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IllustrationTownHouseComposition.default, {
        withBackground: true
      });
    case 'Høyblokk':
    case 'Blokk':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IllustrationHighHouseComposition.default, {
        withBackground: true
      });
    case 'Terrasseblokk':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IllustrationTerraceBlockComposition.default, {
        withBackground: true
      });
    case 'Hus':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IllustrationHouseComposition.default, {
        withBackground: true
      });
    case 'Småhus':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IllustrationSmallHouseComposition.default, {
        withBackground: true
      });
    case 'Flermannsbolig':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IllustrationSemiDetachedHouseComposition.default, {
        withBackground: true
      });
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IllustrationHouseComposition.default, {
        withBackground: true
      });
  }
};
var _default = exports.default = UnitIllustration;
/*
Lavblokk
Høyblokk
Blokk
Terrasseblokk
Enebolig
Småhus
Flermannsbolig
Rekkehus
*/